<template>
    <div>
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" v-show="!isDeleted" />
      <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm" v-show="!isDeleted"/>
      <feather-icon icon="RotateCcwIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openRestoreConfirm" v-show="isDeleted"/>
    </div>
</template>

<script>
export default {
  name: 'UnmappedActionsCellRenderer',
  computed: {
    isDeleted() {
      return this.params.data.isDeleted;
    }
  },
  methods: {
    editRecord () {
      this.params.context.componentParent.editData(this.params.data);
    },
    openDeleteConfirm() {
      this.$deleteConfirmation({
        text: this.$t('Drilling.Unmapped.ConfirmDelete'),
        accept: this.deleteRecord
      });
    },
    deleteRecord () {
      this.params.context.componentParent.deleteData(this.params.data.stagingDailyReportId);
    },
    openRestoreConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: this.$t('Restore'),
        text: this.$t('Drilling.Unmapped.ConfirmRestore'),
        accept: this.restoreRecord
      });
    },
    restoreRecord () {
      this.params.context.componentParent.restoreReport(this.params.data);
    }
  }
}
</script>
